import { ApolloQueryResult, gql } from '@apollo/client';
import { ClosingOffer, GetClosingOfferInput } from '@buy-viasat/types/build/bv';
import { client } from 'shared/containers/apollo';

export type GetClosingOfferPayload = ApolloQueryResult<{ getClosingOffer: ClosingOffer }>;

export const GET_CLOSING_OFFER = gql`
  query getClosingOffer($input: GetClosingOfferInput!) {
    getClosingOffer(input: $input) {
      id
      name
      price
      promo {
        duration
      }
    }
  }
`;

export default async function getClosingOfferAsync(input: GetClosingOfferInput): Promise<GetClosingOfferPayload> {
  return client.query({
    query: GET_CLOSING_OFFER,
    variables: { input },
  });
}
